import React from 'react';
import PropTypes from 'prop-types';
import MarkdownTableRenderer from '../../shared/components/MarkdownRenderers/MarkdownTableRenderer';
import CustomReactMarkdown from '../../shared/components/MarkdownRenderers/CustomReactMarkdown';

function Specifications({ specifications, warranty }) {
    return (
        <>
        <div className='table-container'>
        </div>
            {specifications && (
              <div className="product-description__left-col">
                <h2 className="product-description__title">Specifications</h2>
                <MarkdownTableRenderer className='specifications' markdown={specifications} />
              </div>
            )}
            {warranty && (
              <div className="product-description__right-col">
                <h2 className="product-description__title">Warranty</h2>
                <CustomReactMarkdown className="product-description__long-description" source={warranty} />
              </div>
            )}
        </>
    );

}

Specifications.propTypes = {
  specifications: PropTypes.string,
  warranty: PropTypes.string,
};

export default Specifications;
